// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @08.08.2019 07:18:42
import { SagaObject } from '../../SagaBase/SagaObject';
import * as SagaBase from '../../SagaBase';
import { Guid, GuidTools } from '@models/guid';

export abstract class CrisisCallCard_abstract extends SagaObject {
  static $t: string = 'SagaSchema.CrisisCallCard';
  $t: string = 'SagaSchema.CrisisCallCard';

  public static GetMembers(): string[] {
    return [
      'CreatorId',
      'CreatorName',
      'LinkName',
      'Text',
      'Id',
      'Archived',
      'SubmittedUTC',
      'ArchiveTypeId',
      'Type',
      'MergedGuid',
      'SourceTypeListNameId',
      'DestinationTypeListNameId',
      'SubEventListNameId',
      'MissionTypesListNameId',
      'MissionStatusListNameId',
      'ParticipantsSectorIdsStr',
      'DashboardModelGroupUid'
    ].concat(SagaObject.GetMembers());
  }

  public GetMembers(): string[] {
    return CrisisCallCard_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/
    this.SubmittedUTC = this.SubmittedUTC && new Date(this.SubmittedUTC);

    ///*</AUTO_INIT_CODE>*/
  }

  components(): string[] {
    return [
      'SagaSchema.CEvent',
      'SagaSchema.CLocation',
      'SagaSchema.CNote',
      'SagaSchema.CStampCard',
      'SagaSchema.CrisisMessage',
      'SagaSchema.CTacticalSituation',
      'SagaSchema.CrisisSubEvent',
      'SagaSchema.SourceType',
      'SagaSchema.DestinationType',
      'SagaSchema.CrisisMissionType',
      'SagaSchema.CrisisMissionStatus',
      'SagaSchema.CrisisCallCardProperties'
    ];
  }

  private _components = {};

  component<T>(obj: any): Array<T> {
    let name: string;

    if (typeof obj === 'string') name = <string>obj;
    else if (obj.$t) name = obj.$t;
    else return [];

    if (!this._components[name]) {
      if (this.components().indexOf(name) >= 0) this._components[name] = [];
    }
    return this._components[name];
  }

  public add(obj: any): void {
    var compList = this.component<any>(obj.$t);

    // Only list elements can be added.
    for (var i = 0; i < compList.length; i++)
      if (compList[i].ObjId == obj.ObjId) {
        compList[i] = obj;
        return;
      }
    compList.push(obj);
    obj.ParentObjId = (<any>this).ObjId;
  }

  public remove(obj: any): void {
    if (obj == null) return;

    var compObj = <Array<any>>this.component<any>(obj.$t);
    if (compObj != null) {
      var index = compObj.indexOf(obj);
      if (index >= 0) compObj.splice(index, 1);
    }
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public CreatorId: number;
  public CreatorName: string = '';
  public LinkName: string;
  public Text: string;
  public Id: number = 0;
  public Archived: boolean = false;
  public SubmittedUTC: Date = new Date();
  public ArchiveTypeId: any;
  public Type: number = 0;
  public MergedGuid: Guid = GuidTools.Empty;
  public SourceTypeListNameId: number = 0;
  public DestinationTypeListNameId: number = 0;
  public SubEventListNameId: number = 0;
  public MissionTypesListNameId: number = 0;
  public MissionStatusListNameId: number = 0;
  public ParticipantsSectorIdsStr: string = '';
  public DashboardModelGroupUid: Guid = GuidTools.Empty;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  get ParentObjId(): any {
    return null;
  }
  set ParentObjId(value: any) {}

  /*</AUTO_IMPLEMENTATION>*/
}
